import { useCallback, useEffect, useRef, useState } from 'react';
import { message } from 'antd';
import { useEvents } from '../providers/events';
import { createAttachmentUrl } from '../utils/createAttachmentURL';
import { createNameWithExtension } from '../utils/getAttachmentName';

export const useAttachmentAction = ({ attachment, action, mimeType }) => {
  const actionRef = useRef(action);
  actionRef.current = action;

  const cache = useRef();

  const [loading, setLoading] = useState(false);

  const { getAttachment } = useEvents();

  const handler = useCallback(async () => {
    if (cache.current) {
      const { url, title } = cache.current;
      actionRef.current({ url, title });
      return;
    }

    setLoading(true);

    const urlData = await createAttachmentUrl(
      getAttachment,
      attachment.fileName,
      mimeType
    );

    setLoading(false);

    if (urlData.status === 'error') {
      message.error(urlData.message);
      return;
    }

    const title = createNameWithExtension(attachment);

    actionRef.current({ url: urlData.value, title });

    cache.current = { url: urlData.value, title, removeUrl: urlData.removeUrl };
  }, [getAttachment, attachment, mimeType]);

  useEffect(() => {
    return () => {
      if (cache.current) {
        cache.current.removeUrl();
        cache.current = undefined;
      }
    };
  }, []);

  return { loading, handler };
};
